import { IApplicationState } from '../../types/redux';

export function getRegionParentId(state: IApplicationState) {
  const { parentId } = state.region.currentRegion;

  return parentId;
}
